{
  "_format": "hh-sol-artifact-1",
  "contractName": "PoolFlex",
  "sourceName": "contracts/PoolFlex.sol",
  "abi": [
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "AccuralCalledTooEarly",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "CrossChainError",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        },
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "name": "ExceedsMaxDeposit",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ExcessFeePayment",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "ExcessWithdraw",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "InvalidAccess",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "InvalidLoan",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "InvalidPoolSetting",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "InvalidRepayment",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NotBorrowerManager",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NotLender",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NotPoolAdmin",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NotPoolController",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NotWithdrawController",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "PoolInvalidState",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "PoolNotActive",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "PoolPaused",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "TransferDisabled",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        },
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "name": "ZeroDeposit",
      "type": "error"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "owner",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        }
      ],
      "name": "Approval",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint32",
          "name": "sourceChainId",
          "type": "uint32"
        },
        {
          "indexed": false,
          "internalType": "address",
          "name": "sourcePoolAddr",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "address",
          "name": "destinationWalletAddr",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "address",
          "name": "sourceWalletAddr",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "CrossChainTransferApproveDestination",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint32",
          "name": "destinationChainId",
          "type": "uint32"
        },
        {
          "indexed": false,
          "internalType": "address",
          "name": "destinationPoolAddr",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "address",
          "name": "destinationWalletAddr",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "address",
          "name": "sourceWalletAddr",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "CrossChainTransferApproveSource",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "address",
          "name": "sourceWalletAddr",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "shares",
          "type": "uint256"
        }
      ],
      "name": "CrossChainTransferBurnSource",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "address",
          "name": "destinationWalletAddr",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "shares",
          "type": "uint256"
        }
      ],
      "name": "CrossChainTransferMintDestination",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "sender",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "owner",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "assets",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "shares",
          "type": "uint256"
        }
      ],
      "name": "Deposit",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "version",
          "type": "uint8"
        }
      ],
      "name": "Initialized",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [],
      "name": "PoolCreated",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "lender",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "assets",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "shares",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "transferInDayTimestamp",
          "type": "uint256"
        }
      ],
      "name": "PoolDeposit",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "lender",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "shares",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "assets",
          "type": "uint256"
        }
      ],
      "name": "Redeem",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "lender",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "shares",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "assets",
          "type": "uint256"
        }
      ],
      "name": "RedeemReleased",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "lender",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "assets",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "shares",
          "type": "uint256"
        }
      ],
      "name": "RedeemRequested",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "lender",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "eventId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "shares",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "assets",
          "type": "uint256"
        }
      ],
      "name": "RepayLoanToLender",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "lender",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "eventId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "shares",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "assets",
          "type": "uint256"
        }
      ],
      "name": "RepayToPoolProcessed",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        }
      ],
      "name": "Transfer",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "sender",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "receiver",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "owner",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "assets",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "shares",
          "type": "uint256"
        }
      ],
      "name": "Withdraw",
      "type": "event"
    },
    {
      "inputs": [],
      "name": "accountings",
      "outputs": [
        {
          "components": [
            {
              "internalType": "uint256",
              "name": "interestRate",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "dailyInterestRate",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "totalPrincipalEarningInterest",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "totalInterestAccrued",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "totalAssetsDeposited",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "totalAssetsWithdrawn",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "exchangeRate",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "lastDayAccrued",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "totalFees",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "feesOutstanding",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "interstRateSetTime",
              "type": "uint256"
            }
          ],
          "internalType": "struct IPoolAccountingsFlex",
          "name": "",
          "type": "tuple"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "activatedAt",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "admin",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "owner",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        }
      ],
      "name": "allowance",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "annualAPR",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "estimatedDailyRate",
          "type": "uint256"
        }
      ],
      "name": "annualAPRToDailyRate",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "_dailyInterestRate",
          "type": "uint256"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "principal",
          "type": "uint256"
        }
      ],
      "name": "applyDailyRate",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "approve",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "balanceOf",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "borrowerManagerAddr",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "borrowerVaultAddr",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "borrowerWalletAddr",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "businessDayRegistry",
      "outputs": [
        {
          "internalType": "contract IBusinessDayRegistry",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "closeOfDepositTime",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "closeOfWithdrawTime",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "shares",
          "type": "uint256"
        }
      ],
      "name": "convertToAssets",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "assets",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "assets",
          "type": "uint256"
        }
      ],
      "name": "convertToShares",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "shares",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint32",
          "name": "sourceChainId",
          "type": "uint32"
        },
        {
          "internalType": "address",
          "name": "sourcePoolAddr",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "destinationWalletAddr",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "sourceWalletAddr",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "crossChainTransferApproveDestination",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint32",
          "name": "destinationChainId",
          "type": "uint32"
        },
        {
          "internalType": "address",
          "name": "destinationPoolAddr",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "destinationWalletAddr",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "sourceWalletAddr",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "crossChainTransferApproveSource",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "crossChainTransferBurnSource",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "destinationWalletAddr",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "crossChainTransferMintDestination",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "walletAddr",
          "type": "address"
        }
      ],
      "name": "crossChainTransferStatus",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "internalType": "bool",
          "name": "isCrossChainSource",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "dailyInterestAccural",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "decimals",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "subtractedValue",
          "type": "uint256"
        }
      ],
      "name": "decreaseAllowance",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "assets",
          "type": "uint256"
        },
        {
          "internalType": "address",
          "name": "lender",
          "type": "address"
        }
      ],
      "name": "deposit",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "shares",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "transferInDayTimestamp",
          "type": "uint256"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "exchangeRate",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "_exchangeRate",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "paidAmount",
          "type": "uint256"
        }
      ],
      "name": "feesPaidDown",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "accountAddr",
          "type": "address"
        }
      ],
      "name": "getPoolAccountState",
      "outputs": [
        {
          "components": [
            {
              "internalType": "address",
              "name": "poolAddr",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "accountAddr",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "tokenBalance",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "maxWithdrawRequest",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "maxRedeemRequest",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "requestedSharesOf",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "requestedAssetsOf",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "principalEarningInterest",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "interestAccrued",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "assetsDeposited",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "assetsWithdrawn",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "sharesTransitioningIn",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "assetsTransitioningIn",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "assetsDueForWithdraws",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "sharesDueForWithdraws",
              "type": "uint256"
            }
          ],
          "internalType": "struct IPoolAccountStateFlex",
          "name": "",
          "type": "tuple"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getPoolConfiguration",
      "outputs": [
        {
          "components": [
            {
              "internalType": "address",
              "name": "poolAddr",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "dailyOriginationFeeRate",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "originationFee",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "closeOfDepositTime",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "closeOfWithdrawTime",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "transferInDays",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "transferOutDays",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "liquidityAssetAddr",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolAdminAddr",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolControllerAddr",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "withdrawControllerAddr",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "borrowerVaultAddr",
              "type": "address"
            },
            {
              "internalType": "string",
              "name": "name",
              "type": "string"
            },
            {
              "internalType": "string",
              "name": "symbol",
              "type": "string"
            },
            {
              "internalType": "address",
              "name": "borrowerManagerAddr",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "borrowerWalletAddr",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "maxCapacity",
              "type": "uint256"
            },
            {
              "internalType": "uint64[]",
              "name": "nonBusinessDays",
              "type": "uint64[]"
            },
            {
              "internalType": "address",
              "name": "businessDayRegistryAddr",
              "type": "address"
            }
          ],
          "internalType": "struct IPoolConfigurationStateFlex",
          "name": "",
          "type": "tuple"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getPoolOverview",
      "outputs": [
        {
          "components": [
            {
              "internalType": "address",
              "name": "poolAddr",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "interestRate",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "dailyInterestRate",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "totalPrincipalEarningInterest",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "totalInterestAccrued",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "totalAssetsDeposited",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "totalAssetsWithdrawn",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "exchangeRate",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "totalSupply",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "totalRequestedShares",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "totalRequestedAssets",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "totalAssetsTransitioningIn",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "totalSharesTransitioningIn",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "totalAssetsDueForWithdraws",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "totalFees",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "feesOutstanding",
              "type": "uint256"
            },
            {
              "internalType": "uint64[]",
              "name": "nonBusinessDays",
              "type": "uint64[]"
            },
            {
              "internalType": "uint8",
              "name": "state",
              "type": "uint8"
            },
            {
              "internalType": "uint256",
              "name": "lastDayAccrued",
              "type": "uint256"
            }
          ],
          "internalType": "struct IPoolOverviewStateFlex",
          "name": "",
          "type": "tuple"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "addedValue",
          "type": "uint256"
        }
      ],
      "name": "increaseAllowance",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "components": [
            {
              "internalType": "address",
              "name": "liquidityAsset",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolAdmin",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "serviceConfiguration",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "withdrawDepositControllerFactoryFlex",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolControllerFactoryFlex",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "vaultFactory",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolAccessControlFactory",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "businessDayRegistryFactory",
              "type": "address"
            }
          ],
          "internalType": "struct PoolAddressListFlex",
          "name": "poolAddressListFlex",
          "type": "tuple"
        },
        {
          "components": [
            {
              "internalType": "uint256",
              "name": "maxCapacity",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "borrowerManagerAddr",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "borrowerWalletAddr",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "closeOfDepositTime",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "closeOfWithdrawTime",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "originationFee",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "dailyOriginationFeeRate",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "transferInDays",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "transferOutDays",
              "type": "uint256"
            }
          ],
          "internalType": "struct IPoolConfigurableSettingsFlex",
          "name": "poolSettings",
          "type": "tuple"
        },
        {
          "internalType": "string",
          "name": "tokenName",
          "type": "string"
        },
        {
          "internalType": "string",
          "name": "tokenSymbol",
          "type": "string"
        }
      ],
      "name": "initialize",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "interestRate",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "assets",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "receiver",
          "type": "address"
        }
      ],
      "name": "isPermittedLender",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "liquidityAssetAddr",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "liquidityPoolAssets",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "assets",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "owner",
          "type": "address"
        }
      ],
      "name": "maxDeposit",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "owner",
          "type": "address"
        }
      ],
      "name": "maxRedeemRequest",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "maxShares",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "owner",
          "type": "address"
        }
      ],
      "name": "maxWithdrawRequest",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "maxAssets",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "name",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "nonBusinessDays",
      "outputs": [
        {
          "internalType": "uint64[]",
          "name": "",
          "type": "uint64[]"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "onActivated",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "poolAccessControl",
      "outputs": [
        {
          "internalType": "contract IPoolAccessControl",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "poolController",
      "outputs": [
        {
          "internalType": "contract IPoolControllerFlex",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "poolType",
      "outputs": [
        {
          "internalType": "enum IPoolType",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "shares",
          "type": "uint256"
        }
      ],
      "name": "previewRedeemRequest",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "assets",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "assets",
          "type": "uint256"
        }
      ],
      "name": "previewWithdrawRequest",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "shares",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "eventId",
          "type": "uint256"
        }
      ],
      "name": "releaseWithdrawal",
      "outputs": [
        {
          "components": [
            {
              "internalType": "uint256",
              "name": "requestedShares",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "requestedAssets",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "transferOutDayTimestamp",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "requestTimestamp",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "lender",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "eventId",
              "type": "uint256"
            }
          ],
          "internalType": "struct IPoolLenderWithdrawEvent",
          "name": "ev",
          "type": "tuple"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "assets",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "eventId",
          "type": "uint256"
        }
      ],
      "name": "repayLoans",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "shares",
          "type": "uint256"
        }
      ],
      "name": "requestRedeem",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "assets",
          "type": "uint256"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "serviceConfiguration",
      "outputs": [
        {
          "internalType": "contract IServiceConfigurationV5",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "_interestRate",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "_estimatedDailyRate",
          "type": "uint256"
        }
      ],
      "name": "setDailyInterestRate",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "settings",
      "outputs": [
        {
          "components": [
            {
              "internalType": "uint256",
              "name": "maxCapacity",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "borrowerManagerAddr",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "borrowerWalletAddr",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "closeOfDepositTime",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "closeOfWithdrawTime",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "originationFee",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "dailyOriginationFeeRate",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "transferInDays",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "transferOutDays",
              "type": "uint256"
            }
          ],
          "internalType": "struct IPoolConfigurableSettingsFlex",
          "name": "poolSettings",
          "type": "tuple"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "state",
      "outputs": [
        {
          "internalType": "enum IPoolLifeCycleStateFlex",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "symbol",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "lender",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "catchupShares",
          "type": "uint256"
        }
      ],
      "name": "topOffSharesDueToExchangeRateDecrease",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "totalAssets",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "totalAssetsDueForWithdraws",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "totalAvailableAssets",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "assets",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "totalAvailableSupply",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "shares",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "totalSupply",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "transfer",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "transferFrom",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "transferInDays",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "transferOutDays",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint64[]",
          "name": "_timestamps",
          "type": "uint64[]"
        }
      ],
      "name": "updateNonBusinessDays",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "version",
      "outputs": [
        {
          "internalType": "uint16",
          "name": "",
          "type": "uint16"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "withdrawDepositController",
      "outputs": [
        {
          "internalType": "contract IWithdrawDepositControllerFlex",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "withdrawEvents",
      "outputs": [
        {
          "components": [
            {
              "internalType": "uint256",
              "name": "requestedShares",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "requestedAssets",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "transferOutDayTimestamp",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "requestTimestamp",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "lender",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "eventId",
              "type": "uint256"
            }
          ],
          "internalType": "struct IPoolLenderWithdrawEvent[]",
          "name": "",
          "type": "tuple[]"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    }
  ],
  "bytecode": "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__$8c771c1d2bcbdb7c6fe99211fd846dc7b4$__9063181021ed90610a1790309060040161442e565b600060405180830381865af4158015610a34573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526108cc9190810190615033565b60655460405163babcc53960e01b81526001600160a01b039091169063babcc53990610a8c90339060040161442e565b602060405180830381865afa158015610aa9573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610acd9190615184565b610aea57604051638c38000360e01b815260040160405180910390fd5b6075546040805163290a6c6560e11b8152905133926001600160a01b031691635214d8ca9160048083019260209291908290030181865afa158015610b33573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610b579190614f96565b6001600160a01b031603610b7e57604051638c38000360e01b815260040160405180910390fd5b6000610b89336125ae565b11610ba757604051638c38000360e01b815260040160405180910390fd5b60745460405163dc68db0f60e01b81526001600160a01b039091169063dc68db0f90610bd9903390859060040161519f565b600060405180830381600087803b158015610bf357600080fd5b505af1925050508015610c04575060015b610c2157604051631b16627f60e31b815260040160405180910390fd5b604051638ebb91c560e01b815260009073__$8c771c1d2bcbdb7c6fe99211fd846dc7b4$__90638ebb91c590610c6090309060699087906004016151b8565b602060405180830381865af4158015610c7d573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610ca19190614f49565b90507f0277b5d5d8f2575e1fea0567c8811d3347af77e4d225cce4d4f2be06faa70529338383604051610cd6939291906151b8565b60405180910390a1610ce8338261374a565b610cf0613878565b505b50565b6075546001600160a01b03163314610d205760405163300863cd60e01b815260040160405180910390fd5b6000610d2b8261320c565b90508160696004016000828254610d429190614f78565b9091555050606b8054839190600090610d5c908490614f78565b90915550506074546040516306bf0dd360e01b81526001600160a01b03909116906306bf0dd390610d93908690869060040161519f565b600060405180830381600087803b158015610dad57600080fd5b505af1925050508015610dbe575060015b610ddb57604051631b16627f60e31b815260040160405180910390fd5b610de58382613948565b7f5221e5ff05ba1cf22cde781d788053fa04a216557cd8bbb6334c6198b592d457838383604051610e18939291906151b8565b60405180910390a1610e28613878565b505050565b606060368054610e3c906151d9565b80601f0160208091040260200160405190810160405280929190818152602001828054610e68906151d9565b8015610eb55780601f10610e8a57610100808354040283529160200191610eb5565b820191906000526020600020905b815481529060010190602001808311610e9857829003601f168201915b5050505050905090565b6000610ee6670de0b6b3a7640000610ee0610ed9606f5490565b8590613a04565b90613a10565b92915050565b6067546040516250495760e01b81526101009091046001600160a01b0316906250495790610f1e90339060040161442e565b602060405180830381865afa158015610f3b573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610f5f9190615184565b158015610fde5750606754604051637be53ca160e01b81526101009091046001600160a01b031690637be53ca190610f9b90339060040161442e565b602060405180830381865afa158015610fb8573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610fdc9190615184565b155b15610ffb5760405162b145b560e31b815260040160405180910390fd5b604051630db850a160e31b815273__$8c771c1d2bcbdb7c6fe99211fd846dc7b4$__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__$8c771c1d2bcbdb7c6fe99211fd846dc7b4$__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__$8c771c1d2bcbdb7c6fe99211fd846dc7b4$__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__$8c771c1d2bcbdb7c6fe99211fd846dc7b4$__9063941331dd906120ef903090869086906004016151b8565b60006040518083038186803b15801561210757600080fd5b505af415801561211b573d6000803e3d6000fd5b505050505050565b6075546040805163290a6c6560e11b815290516000926001600160a01b031691635214d8ca9160048083019260209291908290030181865afa15801561091b573d6000803e3d6000fd5b6000610ee682610ebf565b60755460408051632ea9b36f60e11b815290516000926001600160a01b031691635d5366de9160048083019260209291908290030181865afa158015611c28573d6000803e3d6000fd5b60755460408051636e3480b760e01b815290516000926001600160a01b031691636e3480b79160048083019260209291908290030181865afa158015611c28573d6000803e3d6000fd5b600080606760019054906101000a90046001600160a01b03166001600160a01b0316635c975abb6040518163ffffffff1660e01b8152600401602060405180830381865afa158015612262573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906122869190615184565b15156001036122a85760405163146f5dc360e21b815260040160405180910390fd5b600180607560009054906101000a90046001600160a01b03166001600160a01b031663c19d93fb6040518163ffffffff1660e01b8152600401602060405180830381865afa1580156122fe573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906123229190615335565b600381111561233357612333614ca4565b14612351576040516367e554d160e01b815260040160405180910390fd5b60655460405163babcc53960e01b81526001600160a01b039091169063babcc5399061238190339060040161442e565b602060405180830381865afa15801561239e573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906123c29190615184565b6123df57604051638c38000360e01b815260040160405180910390fd5b6075546040805163290a6c6560e11b8152905133926001600160a01b031691635214d8ca9160048083019260209291908290030181865afa158015612428573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061244c9190614f96565b6001600160a01b03160361247357604051638c38000360e01b815260040160405180910390fd5b6040516252e1a160e31b815230600482015260696024820152604481018690526001600160a01b038516606482015273__$8c771c1d2bcbdb7c6fe99211fd846dc7b4$__906302970d08906084016040805180830381865af41580156124dd573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906125019190615356565b606854919450925061251e906001600160a01b0316333088613ed2565b6125288484613948565b61254830612534613229565b6068546001600160a01b0316919088613ed2565b607454604051632b907e9d60e01b8152600481018790526001600160a01b0390911690632b907e9d90602401600060405180830381600087803b15801561258e57600080fd5b505af11580156125a2573d6000803e3d6000fd5b50505050509250929050565b6001600160a01b031660009081526033602052604090205490565b60755460408051633892bbf160e11b815290516000926001600160a01b03169163712577e29160048083019260209291908290030181865afa158015611c28573d6000803e3d6000fd5b60745460408051630788807160e41b815290516060926001600160a01b03169163788807109160048083019260009291908290030181865afa15801561265d573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526108cc91908101906153fc565b60745460408051637329ef3960e11b815290516000926001600160a01b03169163e653de729160048083019260209291908290030181865afa1580156126cf573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906126f39190614f49565b607460009054906101000a90046001600160a01b03166001600160a01b031663cd1032086040518163ffffffff1660e01b8152600401602060405180830381865afa158015612746573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061276a9190614f49565b6035546127779190615322565b6108cc9190615322565b61280c604051806101e0016040528060006001600160a01b0316815260200160006001600160a01b03168152602001600081526020016000815260200160008152602001600081526020016000815260200160008152602001600081526020016000815260200160008152602001600081526020016000815260200160008152602001600081525090565b604051636695bd3b60e01b815260009073__$8c771c1d2bcbdb7c6fe99211fd846dc7b4$__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__$8c771c1d2bcbdb7c6fe99211fd846dc7b4$__9063a934147a90612d5690309060699087906004016151b8565b602060405180830381865af4158015612d73573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610ee69190614f49565b606a54600090670de0b6b3a764000090612db19082614f78565b612dbb9084615249565b610ee69190615276565b604080516102608101825260008082526020820181905281830181905260608083018290526080830182905260a0830182905260c0830182905260e08301829052610100830182905261012083018290526101408301829052610160830182905261018083018190526101a083018190526101c083018290526101e0830182905261020083018290526102208301526102408201529051633b5000a960e21b815273__$8c771c1d2bcbdb7c6fe99211fd846dc7b4$__9063ed4002a490612e9090309060040161442e565b600060405180830381865af4158015612ead573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526108cc91908101906155e9565b6075546001600160a01b03163314612f005760405163300863cd60e01b815260040160405180910390fd5b60655460405163babcc53960e01b81526001600160a01b039091169063babcc53990612f3090859060040161442e565b602060405180830381865afa158015612f4d573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612f719190615184565b612f8e57604051631b16627f60e31b815260040160405180910390fd5b607454604051634094007f60e11b81526001600160a01b039091169063812800fe90612fc0908590859060040161519f565b600060405180830381600087803b158015612fda57600080fd5b505af1925050508015612feb575060015b61300857604051631b16627f60e31b815260040160405180910390fd5b7f411f606961a75add83a58269c3205afcb61321a847f149b8bb333f842cf7b025858585858560405161121e959493929190615213565b6075546040805163c19d93fb60e01b815290516000926001600160a01b03169163c19d93fb9160048083019260209291908290030181865afa158015613089573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906108cc9190615335565b60675460405163eaf6e48360e01b81526101009091046001600160a01b03169063eaf6e483906130e190339060040161442e565b602060405180830381865afa1580156130fe573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906131229190615184565b15806131a257506075546040805163290a6c6560e11b8152905133926001600160a01b031691635214d8ca9160048083019260209291908290030181865afa158015613172573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906131969190614f96565b6001600160a01b031614155b156131c0576040516369c7961360e01b815260040160405180910390fd5b6040516346b8c45d60e11b815230600482015260696024820152604481018390526064810182905273__$8c771c1d2bcbdb7c6fe99211fd846dc7b4$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",
  "deployedBytecode": "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__$8c771c1d2bcbdb7c6fe99211fd846dc7b4$__9063181021ed90610a1790309060040161442e565b600060405180830381865af4158015610a34573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526108cc9190810190615033565b60655460405163babcc53960e01b81526001600160a01b039091169063babcc53990610a8c90339060040161442e565b602060405180830381865afa158015610aa9573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610acd9190615184565b610aea57604051638c38000360e01b815260040160405180910390fd5b6075546040805163290a6c6560e11b8152905133926001600160a01b031691635214d8ca9160048083019260209291908290030181865afa158015610b33573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610b579190614f96565b6001600160a01b031603610b7e57604051638c38000360e01b815260040160405180910390fd5b6000610b89336125ae565b11610ba757604051638c38000360e01b815260040160405180910390fd5b60745460405163dc68db0f60e01b81526001600160a01b039091169063dc68db0f90610bd9903390859060040161519f565b600060405180830381600087803b158015610bf357600080fd5b505af1925050508015610c04575060015b610c2157604051631b16627f60e31b815260040160405180910390fd5b604051638ebb91c560e01b815260009073__$8c771c1d2bcbdb7c6fe99211fd846dc7b4$__90638ebb91c590610c6090309060699087906004016151b8565b602060405180830381865af4158015610c7d573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610ca19190614f49565b90507f0277b5d5d8f2575e1fea0567c8811d3347af77e4d225cce4d4f2be06faa70529338383604051610cd6939291906151b8565b60405180910390a1610ce8338261374a565b610cf0613878565b505b50565b6075546001600160a01b03163314610d205760405163300863cd60e01b815260040160405180910390fd5b6000610d2b8261320c565b90508160696004016000828254610d429190614f78565b9091555050606b8054839190600090610d5c908490614f78565b90915550506074546040516306bf0dd360e01b81526001600160a01b03909116906306bf0dd390610d93908690869060040161519f565b600060405180830381600087803b158015610dad57600080fd5b505af1925050508015610dbe575060015b610ddb57604051631b16627f60e31b815260040160405180910390fd5b610de58382613948565b7f5221e5ff05ba1cf22cde781d788053fa04a216557cd8bbb6334c6198b592d457838383604051610e18939291906151b8565b60405180910390a1610e28613878565b505050565b606060368054610e3c906151d9565b80601f0160208091040260200160405190810160405280929190818152602001828054610e68906151d9565b8015610eb55780601f10610e8a57610100808354040283529160200191610eb5565b820191906000526020600020905b815481529060010190602001808311610e9857829003601f168201915b5050505050905090565b6000610ee6670de0b6b3a7640000610ee0610ed9606f5490565b8590613a04565b90613a10565b92915050565b6067546040516250495760e01b81526101009091046001600160a01b0316906250495790610f1e90339060040161442e565b602060405180830381865afa158015610f3b573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610f5f9190615184565b158015610fde5750606754604051637be53ca160e01b81526101009091046001600160a01b031690637be53ca190610f9b90339060040161442e565b602060405180830381865afa158015610fb8573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610fdc9190615184565b155b15610ffb5760405162b145b560e31b815260040160405180910390fd5b604051630db850a160e31b815273__$8c771c1d2bcbdb7c6fe99211fd846dc7b4$__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__$8c771c1d2bcbdb7c6fe99211fd846dc7b4$__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__$8c771c1d2bcbdb7c6fe99211fd846dc7b4$__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__$8c771c1d2bcbdb7c6fe99211fd846dc7b4$__9063941331dd906120ef903090869086906004016151b8565b60006040518083038186803b15801561210757600080fd5b505af415801561211b573d6000803e3d6000fd5b505050505050565b6075546040805163290a6c6560e11b815290516000926001600160a01b031691635214d8ca9160048083019260209291908290030181865afa15801561091b573d6000803e3d6000fd5b6000610ee682610ebf565b60755460408051632ea9b36f60e11b815290516000926001600160a01b031691635d5366de9160048083019260209291908290030181865afa158015611c28573d6000803e3d6000fd5b60755460408051636e3480b760e01b815290516000926001600160a01b031691636e3480b79160048083019260209291908290030181865afa158015611c28573d6000803e3d6000fd5b600080606760019054906101000a90046001600160a01b03166001600160a01b0316635c975abb6040518163ffffffff1660e01b8152600401602060405180830381865afa158015612262573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906122869190615184565b15156001036122a85760405163146f5dc360e21b815260040160405180910390fd5b600180607560009054906101000a90046001600160a01b03166001600160a01b031663c19d93fb6040518163ffffffff1660e01b8152600401602060405180830381865afa1580156122fe573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906123229190615335565b600381111561233357612333614ca4565b14612351576040516367e554d160e01b815260040160405180910390fd5b60655460405163babcc53960e01b81526001600160a01b039091169063babcc5399061238190339060040161442e565b602060405180830381865afa15801561239e573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906123c29190615184565b6123df57604051638c38000360e01b815260040160405180910390fd5b6075546040805163290a6c6560e11b8152905133926001600160a01b031691635214d8ca9160048083019260209291908290030181865afa158015612428573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061244c9190614f96565b6001600160a01b03160361247357604051638c38000360e01b815260040160405180910390fd5b6040516252e1a160e31b815230600482015260696024820152604481018690526001600160a01b038516606482015273__$8c771c1d2bcbdb7c6fe99211fd846dc7b4$__906302970d08906084016040805180830381865af41580156124dd573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906125019190615356565b606854919450925061251e906001600160a01b0316333088613ed2565b6125288484613948565b61254830612534613229565b6068546001600160a01b0316919088613ed2565b607454604051632b907e9d60e01b8152600481018790526001600160a01b0390911690632b907e9d90602401600060405180830381600087803b15801561258e57600080fd5b505af11580156125a2573d6000803e3d6000fd5b50505050509250929050565b6001600160a01b031660009081526033602052604090205490565b60755460408051633892bbf160e11b815290516000926001600160a01b03169163712577e29160048083019260209291908290030181865afa158015611c28573d6000803e3d6000fd5b60745460408051630788807160e41b815290516060926001600160a01b03169163788807109160048083019260009291908290030181865afa15801561265d573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526108cc91908101906153fc565b60745460408051637329ef3960e11b815290516000926001600160a01b03169163e653de729160048083019260209291908290030181865afa1580156126cf573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906126f39190614f49565b607460009054906101000a90046001600160a01b03166001600160a01b031663cd1032086040518163ffffffff1660e01b8152600401602060405180830381865afa158015612746573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061276a9190614f49565b6035546127779190615322565b6108cc9190615322565b61280c604051806101e0016040528060006001600160a01b0316815260200160006001600160a01b03168152602001600081526020016000815260200160008152602001600081526020016000815260200160008152602001600081526020016000815260200160008152602001600081526020016000815260200160008152602001600081525090565b604051636695bd3b60e01b815260009073__$8c771c1d2bcbdb7c6fe99211fd846dc7b4$__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__$8c771c1d2bcbdb7c6fe99211fd846dc7b4$__9063a934147a90612d5690309060699087906004016151b8565b602060405180830381865af4158015612d73573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610ee69190614f49565b606a54600090670de0b6b3a764000090612db19082614f78565b612dbb9084615249565b610ee69190615276565b604080516102608101825260008082526020820181905281830181905260608083018290526080830182905260a0830182905260c0830182905260e08301829052610100830182905261012083018290526101408301829052610160830182905261018083018190526101a083018190526101c083018290526101e0830182905261020083018290526102208301526102408201529051633b5000a960e21b815273__$8c771c1d2bcbdb7c6fe99211fd846dc7b4$__9063ed4002a490612e9090309060040161442e565b600060405180830381865af4158015612ead573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526108cc91908101906155e9565b6075546001600160a01b03163314612f005760405163300863cd60e01b815260040160405180910390fd5b60655460405163babcc53960e01b81526001600160a01b039091169063babcc53990612f3090859060040161442e565b602060405180830381865afa158015612f4d573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612f719190615184565b612f8e57604051631b16627f60e31b815260040160405180910390fd5b607454604051634094007f60e11b81526001600160a01b039091169063812800fe90612fc0908590859060040161519f565b600060405180830381600087803b158015612fda57600080fd5b505af1925050508015612feb575060015b61300857604051631b16627f60e31b815260040160405180910390fd5b7f411f606961a75add83a58269c3205afcb61321a847f149b8bb333f842cf7b025858585858560405161121e959493929190615213565b6075546040805163c19d93fb60e01b815290516000926001600160a01b03169163c19d93fb9160048083019260209291908290030181865afa158015613089573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906108cc9190615335565b60675460405163eaf6e48360e01b81526101009091046001600160a01b03169063eaf6e483906130e190339060040161442e565b602060405180830381865afa1580156130fe573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906131229190615184565b15806131a257506075546040805163290a6c6560e11b8152905133926001600160a01b031691635214d8ca9160048083019260209291908290030181865afa158015613172573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906131969190614f96565b6001600160a01b031614155b156131c0576040516369c7961360e01b815260040160405180910390fd5b6040516346b8c45d60e11b815230600482015260696024820152604481018390526064810182905273__$8c771c1d2bcbdb7c6fe99211fd846dc7b4$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",
  "linkReferences": {
    "contracts/libraries/PoolLibFlex.sol": {
      "PoolLibFlex": [
        {
          "length": 20,
          "start": 2792
        },
        {
          "length": 20,
          "start": 3372
        },
        {
          "length": 20,
          "start": 4355
        },
        {
          "length": 20,
          "start": 5755
        },
        {
          "length": 20,
          "start": 7511
        },
        {
          "length": 20,
          "start": 8636
        },
        {
          "length": 20,
          "start": 9629
        },
        {
          "length": 20,
          "start": 10519
        },
        {
          "length": 20,
          "start": 11810
        },
        {
          "length": 20,
          "start": 12129
        },
        {
          "length": 20,
          "start": 13027
        }
      ]
    }
  },
  "deployedLinkReferences": {
    "contracts/libraries/PoolLibFlex.sol": {
      "PoolLibFlex": [
        {
          "length": 20,
          "start": 2543
        },
        {
          "length": 20,
          "start": 3123
        },
        {
          "length": 20,
          "start": 4106
        },
        {
          "length": 20,
          "start": 5506
        },
        {
          "length": 20,
          "start": 7262
        },
        {
          "length": 20,
          "start": 8387
        },
        {
          "length": 20,
          "start": 9380
        },
        {
          "length": 20,
          "start": 10270
        },
        {
          "length": 20,
          "start": 11561
        },
        {
          "length": 20,
          "start": 11880
        },
        {
          "length": 20,
          "start": 12778
        }
      ]
    }
  }
}
